import script from "./Xmas.vue?vue&type=script&setup=true&lang=js"
export * from "./Xmas.vue?vue&type=script&setup=true&lang=js"

import "./Xmas.vue?vue&type=style&index=0&id=16d35149&lang=sass"

const __exports__ = script;

export default __exports__